import React, { PropTypes } from 'react'
import { DayPicker } from 'react-dates'
import CSSModules from 'react-css-modules'

import Button from 'components/grid-form-button'

import styles from './date-range-picker.css'

const DateRangePicker = ({
  dates,
  format,
  onCancel,
  onDayClick,
  onSave,
  isEndDate,
  isInSelectedSpan,
  isStartDate,
}) => (
  <div styleName="date-range-picker">
    <DayPicker
      modifiers={{
        weekend: date => date.day() === 6 || date.day() === 0,
        selected: date => dates.indexOf(format(date)) > -1,
        'selected-start': date => isStartDate(date),
        'selected-end': date => isEndDate(date),
        'selected-span': date => isInSelectedSpan(date),
      }}
      numberOfMonths={2}
      onDayClick={onDayClick}
    />
    <div styleName="actions">
      <Button secondary name="Cancel" onClick={onCancel} />
      <Button name="Save" onClick={onSave} />
    </div>
  </div>
)

DateRangePicker.propTypes = {
  dates: PropTypes.any,
  format: PropTypes.any,
  onCancel: PropTypes.any,
  onDayClick: PropTypes.any,
  onSave: PropTypes.any,
  isEndDate: PropTypes.any,
  isInSelectedSpan: PropTypes.any,
  isStartDate: PropTypes.any,
}

export default CSSModules(DateRangePicker, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/date-range-picker/date-range-picker.js
 **/